/* Lazy-load and play 10K Club celebration clips only when visible. */
(function () {
  const videos = document.querySelectorAll('.ten-k-club-videos__video[data-src]');
  if (!videos.length) return;

  const loadVideo = (video) => {
    const src = video.dataset.src;
    if (!src || video.dataset.loaded === 'true') return;

    const source = document.createElement('source');
    source.src = src;
    source.type = 'video/mp4';
    video.appendChild(source);
    video.dataset.loaded = 'true';
    video.load();
  };

  const playVideo = (video) => {
    loadVideo(video);
    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {});
    }
  };

  const pauseVideo = (video) => {
    video.pause();
  };

  if (!('IntersectionObserver' in window)) {
    videos.forEach((video) => playVideo(video));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          playVideo(video);
        } else {
          pauseVideo(video);
        }
      });
    },
    { rootMargin: '120px 0px', threshold: 0.15 }
  );

  videos.forEach((video) => observer.observe(video));
})();
